import React, {Component} from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import constants from '../parameters/constants';
import {withNamespaces} from 'react-i18next';

const ErrorContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  border-bottom: 3px solid red;
  background: ${constants.primaryColor};
  z-index: 1000;
  color: white;
  padding: 20px;
  padding-bottom: 40px;
  font-size: 20px;
`;

class ErrorMessage extends Component {
  static state = {
    timeout: false,
  };

  timeout = undefined;

  static propTypes = {
    errors: PropTypes.array,
    clearErrors: PropTypes.func.isRequired,
  };

  clearTimeout = () => this.timeout && clearTimeout(this.timeout);

  componentWillReceiveProps(newProps) {
    if (newProps.errors && newProps.errors.length > 0) {
      this.clearTimeout();
      this.timeout = setTimeout(() => {
        this.props.clearErrors();
      }, 4000);
    }
  }

  componentWillUnmount() {
    this.clearTimeout();
  }

  render() {
    const {errors, t} = this.props;
    if (!errors || errors.length === 0) {
      return null;
    }

    return (
      <ErrorContainer>
        <h2>{t('error.header')}</h2>
        {errors.map((error, i) => {
          let err = error;
          if (error.message) {
            err = error.message;
          }
          return <div key={'error_' + i}>{err}</div>;
        })}
      </ErrorContainer>
    );
  }
}

export default withNamespaces()(ErrorMessage);



// WEBPACK FOOTER //
// ./src/components/ErrorMessage.js